import React from 'react';
import { 
    Form, 
    Input, 
    Button, 
    Space, 
    message, 
    Card, 
    Divider,
    Row,
    Col,
    Tooltip,
    Alert
} from 'antd';
import { 
    SaveOutlined, 
    ReloadOutlined,
    QuestionCircleOutlined 
} from '@ant-design/icons';

const SmsConfig = () => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        fetchSmsConfig();
    }, []);

    const fetchSmsConfig = async () => {

        try {
            const response = await fetch(`/api/promotion/sms/config/get`);
            const result = await response.json();

            if (result.success) {
                // 设置表单初始值，但不触发验证
                form.setFieldsValue({
                    accessKeyId: result.data.accessKeyId || '',
                    accessKeySecret: result.data.accessKeySecret || '',
                    signName: result.data.signName || '',
                    templateCode: result.data.templateCode || ''
                });
            } else {
                // message.error(result.data || '获取短信配置失败');
            }
        } catch (error) {
            // console.error('获取短信配置失败:', error);
            // message.error('获取短信配置失败');
        }
    };

    // 保存配置
    const onSaveConfig = async () => {
        try {
            const values = await form.validateFields();

            const response = await fetch(`/api/promotion/sms/config/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            });

            const result = await response.json();

            if (result.success) {
                message.success('短信配置保存成功');
            } else {
                message.error(result.data || '短信配置保存失败');
            }
        } catch (error) {
            console.error('保存短信配置失败:', error);
            message.error('保存短信配置失败');
        }
    };

    // 重置表单
    const onReset = () => {
        form.resetFields();
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>阿里云短信配置</h2>
            <Alert
                message="谨慎修改，如需帮助请联系优选到家技术支持"
                type="warning"
                showIcon
                style={{ marginBottom: '10px' }}
            />
            <Alert
                message="仅支持阿里云配置"
                type="info"
                showIcon
                style={{ marginBottom: '10px' }}
            />
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    accessKeyId: '',
                    accessKeySecret: '',
                    signName: '',
                    templateCode: ''
                }}
            >
                <Form.Item
                    label={
                        <span>
                            AccessKeyId&nbsp;
                            <Tooltip title="阿里云账户的AccessKey ID，用于标识API调用者身份">
                                <QuestionCircleOutlined style={{ fontSize: '12px' }} />
                            </Tooltip>
                        </span>
                    }
                    name="accessKeyId"
                    rules={[
                        {
                            required: true,
                            message: '请输入AccessKeyId',
                        }
                    ]}
                >
                    <Input.Password 
                        placeholder="请输入阿里云AccessKeyId" 
                        visibilityToggle={false}
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span>
                            AccessKeySecret&nbsp;
                            <Tooltip title="阿里云账户的AccessKey Secret，用于API调用时的签名验证">
                                <QuestionCircleOutlined style={{ fontSize: '12px' }} />
                            </Tooltip>
                        </span>
                    }
                    name="accessKeySecret"
                    rules={[
                        {
                            required: true,
                            message: '请输入AccessKeySecret',
                        }
                    ]}
                >
                    <Input.Password 
                        placeholder="请输入阿里云AccessKeySecret" 
                        visibilityToggle={false}
                    />
                </Form.Item>

                <Divider />

                <Form.Item>
                    <Space>
                        <Button 
                            type="primary" 
                            onClick={onSaveConfig}
                        >
                            保存配置
                        </Button>
                        <Button 
                            onClick={onReset}
                        >
                            重置
                        </Button>
                        <Button href='/promotion/sms'>
                            返回
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    );
};

export default SmsConfig;